export default "__VITE_ASSET__Csg306Qq__"